export default __webpack_public_path__ + "static/logo-crowder-81aa23363db6df66c9f04c2eafd8dce0.png";